import type React from "react";
import { translateNodeLabel } from "~/components/KratosFlow/translate";
import type { NodeInputProps } from "./helpers";

export const NodeInputCheckbox: React.FC<NodeInputProps> = ({
	node,
	attributes,
	setValue,
	disabled,
}) => {
	const id = Math.random().toString(36).substring(2);
	return (
		<>
			<input
				type="checkbox"
				name={attributes.name}
				defaultChecked={attributes.value}
				onChange={(e) => setValue(e.target.checked)}
				disabled={attributes.disabled || disabled}
				id={id}
			/>
			<label htmlFor={id}>{translateNodeLabel(node)}</label>
		</>
	);
};
